'use strict';
import { useSelector } from 'react-redux';
import config from '~/config';
import { VALID_DOMAIN_ENDINGS } from '~/constants';
import { getCurrentUser } from '~/store/auth/selectors';
import { User } from '~/typings/user';

export const useCurrentUser = () => useSelector(getCurrentUser);

const getValidDomains = (): string[] => {
  if (
    typeof config.REDIRECT_WHITELISTED_DOMAINS === 'string' &&
    !!config.REDIRECT_WHITELISTED_DOMAINS
  ) {
    const envWhitelist = config.REDIRECT_WHITELISTED_DOMAINS.split(',');
    return [...VALID_DOMAIN_ENDINGS, ...envWhitelist];
  }
  return VALID_DOMAIN_ENDINGS;
};

const hostnameMatchesEnding = (hostname: string, ending: string): boolean => {
  // Entries must start with '.' so 'evil-primer.ai' cannot match a 'primer.ai' entry;
  // the bare form is matched separately to still allow the apex domain.
  if (!ending.startsWith('.') || ending.length < 2) {
    return false;
  }
  const bare = ending.slice(1);
  return hostname === bare || hostname.endsWith(ending);
};

export const urlIsValid = (value: string | null | undefined): boolean => {
  if (!value) {
    return false;
  }
  try {
    const { hostname, protocol } = new URL(value);
    if (protocol !== 'https:') {
      return false;
    }
    return getValidDomains().some(ending =>
      hostnameMatchesEnding(hostname, ending),
    );

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (err) {
    return false;
  }
};

export const userIsValid = (user: User | null) => {
  if (user === null) {
    return false;
  }
  // todo: inspect the user to see which properties they have access to
  return typeof user.key === 'string';
};

export const redirectIsValid = (
  url: string | undefined | null,
  user: User | null,
) => urlIsValid(url) && userIsValid(user);
